module.exports = __webpack_public_path__ + "static/hyperv_8.b4c79783.jpg";